import Navigation from "@/components/layout/Navigation";
import Footer from "@/components/layout/Footer";
import OptimizedHero from "@/components/enhanced/OptimizedHero";
import ProblemSection from "@/components/landing/ProblemSection";
import ProblemSolution from "@/components/landing/ProblemSolution";
import ProcessSection from "@/components/landing/ProcessSection";
import QualificationSection from "@/components/landing/QualificationSection";
import Packages from "@/components/landing/Packages";
import FinalCTA from "@/components/landing/FinalCTA";
import NewsletterSubscription from "@/components/layout/NewsletterSubscription";

import OptimizedScrollReveal from "@/components/enhanced/OptimizedScrollReveal";
import { 
  ROICalculatorWrapper, 
  ProcessTimelineWrapper, 
  FAQWrapper 
} from "@/components/LazyComponentLoader";

const Index = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navigation />
      <main>
        <OptimizedHero />
        <OptimizedScrollReveal delay={100}>
          <ProblemSection />
        </OptimizedScrollReveal>
        <OptimizedScrollReveal delay={200}>
          <ProblemSolution />
        </OptimizedScrollReveal>
        <OptimizedScrollReveal delay={100}>
          <ProcessSection />
        </OptimizedScrollReveal>
        <OptimizedScrollReveal delay={100}>
          <QualificationSection />
        </OptimizedScrollReveal>
        <OptimizedScrollReveal delay={400}>
          <ProcessTimelineWrapper />
        </OptimizedScrollReveal>
        <OptimizedScrollReveal delay={300}>
          <ROICalculatorWrapper />
        </OptimizedScrollReveal>
        <OptimizedScrollReveal delay={200}>
          <Packages />
        </OptimizedScrollReveal>
        <OptimizedScrollReveal delay={200}>
          <FAQWrapper />
        </OptimizedScrollReveal>
        <OptimizedScrollReveal delay={300}>
          <FinalCTA />
        </OptimizedScrollReveal>
      </main>
      <NewsletterSubscription />
      <Footer />
    </div>
  );
};

export default Index;
